import jsPDF from "jspdf";
import { PrintDataEntitas } from "@/domain/entities/Booking";
import { ellipsisString } from "@/app/infrastructures/misc/Utils";

export const TableProductsSection = (
  params: {
    doc: jsPDF | any;
    bookingType: string;
    accountType: string;
    data: PrintDataEntitas;
    pieceData: any;
    barcode: string;
    vendorRefCode: string;
    barcodeValue: string;
    vendorRefCodeValue: string;
    logo: string;
    shipmentId: string;
    startX: number;
    startY: number;
  },
  translate: Function
) => {
  const left = params.startX + 2;
  const width = 100;
  const startY = params.startY + 105;
  const rowHeight = 4.5;
  const nameOffset = 8;

  const drawHeader = (yPos: number) => {
    params.doc.setFont("Montserrat", "bold");
    params.doc.setFontSize(7);
    params.doc.setTextColor("#333333");
    params.doc.text(translate("receipt.no"), left, yPos);
    params.doc.text(translate("receipt.productName"), left + nameOffset, yPos);
    params.doc.text(translate("receipt.variant"), left + width - 23, yPos);
    params.doc.text(translate("receipt.quantity"), left + width - 4, yPos, null, null, "right");
    params.doc.setLineWidth(0.1);
    params.doc.line(left, yPos + 1, left + width, yPos + 1);
    return yPos + 3.5;
  };

  let currentY = drawHeader(startY);
  let counter = 0;

  params.doc.setFont("Montserrat", "semibold");
  params.doc.setFontSize(6);
  params.doc.setTextColor("#333333");

  const products = (params.data.sttProducts || []).slice(0, 8);
  for (const p of products) {
    const nextY = currentY + rowHeight;
    counter += 1;
    const name = ellipsisString(p.productName, 50);
    const variant = p.variant ? ellipsisString(p.variant, 10) : '-';
    params.doc.text(String(counter), left, currentY);
    params.doc.text(name, left + nameOffset, currentY);
    params.doc.text(variant, left + width - 23, currentY);
    params.doc.text(String(p.quantity), left + width - 4, currentY, null, null, "right");
    params.doc.setLineWidth(0.1);
    params.doc.line(left, currentY + 1.5, left + width, currentY + 1.5);
    currentY = nextY;
  }
};
